import { createApiRef } from '@backstage/frontend-plugin-api';
import { DefaultApiResponse } from '@internal/backstage-plugin-devops-react';
import {
  ExtendedRbacPolicy,
  ExtendedRbacRole,
  ExtendedRbacRoleVersion,
  RbacMember,
  RbacPermissionsMetadata,
  RbacPolicy,
  RbacRole,
} from '@internal/backstage-plugin-devops-rbac-common';

export const rbacApiRef = createApiRef<RbacApi>().with({
  id: 'rbac-api',
  pluginId: 'devops-rbac',
});

export interface RbacApi {
  getRoles(): Promise<ExtendedRbacRole[]>;
  getRole(roleId: string): Promise<ExtendedRbacRole>;
  createRole(data: RbacRole): Promise<DefaultApiResponse>;
  editRole(id: string, data: RbacRole): Promise<DefaultApiResponse>;
  deleteRole(id: string): Promise<DefaultApiResponse>;

  getMembers(roleId: string, roleVersionId: string): Promise<RbacMember[]>;
  addMembers(
    roleId: string,
    roleVersionId: string,
    membersEntityRefs: string[],
  ): Promise<DefaultApiResponse>;
  deleteMember(
    roleId: string,
    roleVersionId: string,
    memberId: string,
  ): Promise<DefaultApiResponse>;

  getPolicies(roleId: string, roleVersionId: string): Promise<RbacPolicy[]>;
  addPolicy(
    roleId: string,
    roleVersionId: string,
    data: ExtendedRbacPolicy,
  ): Promise<DefaultApiResponse>;
  editPolicy(
    roleId: string,
    roleVersionId: string,
    policyId: string,
    data: ExtendedRbacPolicy,
  ): Promise<DefaultApiResponse>;
  deletePolicy(
    roleId: string,
    roleVersionId: string,
    policyId: string,
  ): Promise<DefaultApiResponse>;
  reorderPolicy(
    roleId: string,
    roleVersionId: string,
    policyId: string,
    reorderDirection: number,
  ): Promise<DefaultApiResponse>;

  getPermissions(): Promise<RbacPermissionsMetadata[]>;

  getRoleVersion(
    roleId: string,
    roleVersionId: string,
  ): Promise<ExtendedRbacRoleVersion>;
  createNewVersionOfRole(
    roleId: string,
    roleVersionToCopyId: string,
  ): Promise<DefaultApiResponse>;
  activateRoleVersion(
    roleId: string,
    roleVersionId: string,
  ): Promise<DefaultApiResponse>;
  deleteRoleVersion(
    roleId: string,
    roleVersionId: string,
  ): Promise<DefaultApiResponse>;
}
